// src/components/admin/flows/components/StepIcon.js
import React from 'react';
import {
    Zap, GitFork, Play, CheckSquare, Clock, Square,
    Bell, Mail, UserPlus, FileText, ListChecks, BarChart3,
    DollarSign, Receipt
} from 'lucide-react';

const STEP_TYPE_CONFIG = {
    trigger: { icon: Zap, color: 'text-green-500', bg: 'bg-green-100 dark:bg-green-900/30' },
    condition: { icon: GitFork, color: 'text-amber-500', bg: 'bg-amber-100 dark:bg-amber-900/30' },
    action: { icon: Play, color: 'text-blue-500', bg: 'bg-blue-100 dark:bg-blue-900/30' },
    approval: { icon: CheckSquare, color: 'text-purple-500', bg: 'bg-purple-100 dark:bg-purple-900/30' },
    delay: { icon: Clock, color: 'text-gray-500', bg: 'bg-gray-100 dark:bg-gray-700' },
    end: { icon: Square, color: 'text-red-500', bg: 'bg-red-100 dark:bg-red-900/30' },
};

const ACTION_TYPE_ICONS = {
    send_notification: Bell,
    send_email: Mail,
    create_task: ListChecks,
    assign_task: UserPlus,
    create_document: FileText,
    run_report: BarChart3,
    process_payroll: DollarSign,
    generate_payslips: Receipt,
};

const StepIcon = ({ type, actionType, size = 'sm', className = '' }) => {
    const config = STEP_TYPE_CONFIG[type] || STEP_TYPE_CONFIG.action;
    let Icon = config.icon;

    // Use more specific icon for action types
    if (type === 'action' && actionType && ACTION_TYPE_ICONS[actionType]) {
        Icon = ACTION_TYPE_ICONS[actionType];
    }

    const sizeClasses = {
        xs: 'w-3 h-3',
        sm: 'w-4 h-4',
        md: 'w-5 h-5',
        lg: 'w-6 h-6',
    };

    return (
        <div className={`inline-flex items-center justify-center p-1.5 rounded-lg ${config.bg} ${className}`}>
            <Icon className={`${sizeClasses[size]} ${config.color}`} />
        </div>
    );
};

export { STEP_TYPE_CONFIG, ACTION_TYPE_ICONS };
export default StepIcon;
